import * as angular from 'angular';
import { DirectiveDefinition } from './directiveDefinition';

type Arrow = {
    left: number;
    up: number;
    right: number;
    down: number;
};

class WtNavigatableController implements angular.IController {
    static $inject = ['$element'];

    constructor(private _$element: angular.IAugmentedJQuery) {
    }

    $onInit() {
        this._$element.on('keydown.wtNavigatable', 'input', { self: this }, this.handleNavigation);
    }

    $onDestroy() {
        this._$element.off('keydown.wtNavigatable');
    }

    handleReturnKey(e: JQueryEventObject): JQuery {
        const key = e.keyCode ? e.keyCode : e.which;
        if (key === 13) {
            const td = $(e.target).closest('td');
            const pos = (td[0] as HTMLTableCellElement).cellIndex;
            const moveToRow = td.closest('tr').next('tr');

            return moveToRow.length
                ? $((moveToRow[0] as HTMLTableRowElement).cells[pos])
                : undefined;
        }
        return undefined;
    }

    handleArrowNavigation(e: JQueryEventObject, arrow: Arrow): JQuery<Element> {
        const input = e.target as HTMLInputElement;
        const td = $(e.target).closest('td');

        let moveTo: JQuery<Element> = null;

        switch (e.which) {
            case arrow.left: {
                if (input.selectionStart === 0) {
                    moveTo = td.prev('td:has(input,textarea)');
                }
                break;
            }
            case arrow.right: {
                if (input.selectionEnd === input.value.length) {
                    moveTo = td.next('td:has(input,textarea)');
                }
                break;
            }

            case arrow.up:
            case arrow.down: {
                const tr = td.closest('tr');
                const pos = (td[0] as HTMLTableCellElement).cellIndex;

                let moveToRow = null;
                if (e.which === arrow.down) {
                    moveToRow = tr.next('tr');
                }
                else if (e.which === arrow.up) {
                    moveToRow = tr.prev('tr');
                }

                if (moveToRow.length) {
                    moveTo = $(moveToRow[0].cells[pos]);
                }

                break;
            }
        }
        return moveTo;
    }

    handleNavigation(e: JQueryEventObject) {
        const self: WtNavigatableController = e.data.self;
        const arrow: Arrow = { left: 37, up: 38, right: 39, down: 40 };
        let moveTo: JQuery<Element> = null;

        // Manage return key
        moveTo = self.handleReturnKey(e);
        if (!moveTo) {
            // Only allow arrow key
            if ($.inArray(e.which, [arrow.left, arrow.up, arrow.right, arrow.down]) < 0) {
                return;
            }

            // Manage arrow navigation
            moveTo = self.handleArrowNavigation(e, arrow);
        }

        if (moveTo && moveTo.length) {
            e.preventDefault();
            moveTo.find('input,textarea').each((i, input: HTMLInputElement) => {
                input.focus();
                // do not select seems more fluid
                // input.select();
            });
        }
    }
}

export const WtNavigatableDirective: DirectiveDefinition = {
    directiveId: 'wtNavigatable',
    restrict: 'A',
    controller: WtNavigatableController,
    controllerAs: 'vm',
    bindToController: true,
    scope: {}
};